import { Component, Input, OnInit } from "@angular/core";
import { Editor, Toolbar } from "ngx-editor";

@Component({
    selector: 'app-text-editor',
    templateUrl: './text-editor.component.html',
    styleUrls: ['./text-editor.component.scss'],
    standalone: false
})
export class TextEditorComponent implements OnInit {
    
    @Input() htmlContent: string | null = '';
    @Input() placeholder: string = '';

    editor: Editor;
    editorToolbar: Toolbar = [];

    constructor() {
    }

    ngOnInit() {
        this.editor = new Editor();
        this.editorToolbar = [
        // default value
            ['bold', 'italic', 'underline'],
            ['align_left', 'align_center', 'align_right', 'align_justify'],
            ['ordered_list', 'bullet_list'],
            ['text_color', 'background_color'],
        ];
    }
}